var _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_568_1361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6411 6H10.5295C10.4642 6 10.4056 6.03997 10.3818 6.10072L8.08474 11.9655C8.04401 12.0694 8.12069 12.1818 8.23236 12.1818H11.2583C11.3607 12.1818 11.4362 12.2774 11.4126 12.377L10.2945 17.0785C10.2531 17.2526 10.4868 17.3512 10.5826 17.2001L15.4554 9.51617C15.5223 9.41061 15.4465 9.27273 15.3215 9.27273H12.7358C12.6223 9.27273 12.5456 9.15698 12.5898 9.05246L13.7871 6.22027C13.8313 6.11575 13.7546 6 13.6411 6Z",
    fill: "#FFB800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_568_1361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.c45ad44a9bd169d505d06f649abce09e.svg";
export { ForwardRef as ReactComponent };